__turbopack_context__.v({
  "className": "dm_mono_d55a275-module__qTJPSG__className",
});
